export default __webpack_public_path__ + "static/media/logo-dark.0c42c4f2.svg";